import React from "react";
import EndDateRow from "./EndDateRow";

/**
 * The Hourly recurrence row. The end-date control it used to carry inline is shared
 * with the Daily and Weekly rows now — see `EndDateRow` for what was duplicated and
 * why it mattered.
 */
const HourRepeatSchedule = ({
  scheduleInfo,
  openDatePicker,
  setOpenDatePicker,
  setScheduleInfo,
}) => (
  <EndDateRow
    label="Occurs every hour until."
    instanceId="connectors-schedule-hour-end-date"
    scheduleInfo={scheduleInfo}
    setScheduleInfo={setScheduleInfo}
    openDatePicker={openDatePicker}
    setOpenDatePicker={setOpenDatePicker}
  />
);

export default HourRepeatSchedule;
